<div *ngIf="showCountdown">
  <h3 class="response-countdown">
    Time left to respond: 
    {{days}} days, {{hours}} hours, {{minutes}} minutes, {{seconds}} seconds
  </h3>
</div>